import React, {Component} from 'react';
import axios from 'axios';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dialog} from "primereact/dialog";


export default class crud extends Component {


    constructor(props) {
        super(props);
        this.onChangeName = this.onChangeName.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.onChangeCode = this.onChangeCode.bind(this);
        this.onChangeUrl = this.onChangeUrl.bind(this);
        this.onChangeLockSystem = this.onChangeLockSystem.bind(this);


        this.state = {
            md_id: null,
            md_name: '',
            md_code: '',
            md_url: '',
            md_list: [],
            md_locksystem: '',
            moduleID: null,
            moduleDeleteDialog: false,
            clean_button: 'none',
            clean_button_add: 'block',
            moduleDialog: false,


        }
    }

    onChangeName(e) {
        this.setState({
            md_name: e.target.value
        })
    }

    onChangeCode(e) {
        this.setState({
            md_code: e.target.value
        })
    }

    onChangeUrl(e) {
        this.setState({
            md_url: e.target.value
        })
    }

    onChangeLockSystem(e) {
        this.setState({
            md_locksystem: e.target.value
        })
    }


    getModules() {
        axios.get('/api/modules/')
            .then(res => {

                this.setState({
                    md_list: res.data.modules,


                });
            })
    }

    componentDidMount() {
        this.getModules();

    }


    renderFooter() {

        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => this.setState({moduleDeleteDialog: false})}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => this.deleteUser(this.state.moduleID)} autoFocus/>
            </div>
        );
    }


    reset = () => {
        this.setState({

            md_name: '',
            md_code: '',
            md_url: ''


        })
    }

    onSubmit(e) {
        e.preventDefault();
        const obj = {
            md_id: this.state.md_id,
            md_name: this.state.md_name,
            md_code: this.state.md_code,
            md_url: this.state.md_url,
            md_locksystem: this.state.md_locksystem

        };
        if (this.state.md_id) {
            //console.log("adasd", this.state.md_id)
            axios.put('/api/modules' + `/${this.state.md_id}/`, obj)
                .then(res => {
                    // ToastsStore.success('Successfully Updated!');
                    this.getModules();
                    //console.log("waddadad", res.data)


                });
        } else {
            axios.post('/api/modules/', obj)
                .then(res => {
                    const data = res.data

                    this.getModules();
                })


        }
        this.setState({

            md_name: '',
            md_code: '',
            md_id: '',
            md_url: ''


        })
    }

    editRow = (md_id, md_name, md_code, md_url) => {
        this.setState({

            md_name: md_name,
            md_id: md_id,
            md_code: md_code,
            md_url: md_url,
            clean_button: 'block',
            clean_button_add: 'block',
            moduleDialog: true,


        })
    }


    deleteRow = (md_id) => {

        this.setState({
            moduleDeleteDialog: true,
            moduleID: md_id
        })


    }
    deleteUser = (md_id) => {
        axios.delete('/api/modules' + `/${md_id}/`)
            .then(res => {
                const data = res.data


                this.getModules();
                this.setState({
                    moduleDeleteDialog: false,
                    moduleID: null
                })

            });


    };

    actionTemplate(rowData) {
        //    //console.log(rowData['md_id'])
        return <div>


            <div>
                <Button
                    type="submit"
                    title="Düzenle"
                    icon="pi pi-pencil"
                    className="p-button-warning"
                    onClick={() => this.editRow(rowData['md_id'], rowData['md_name'], rowData['md_code'], rowData['md_url'])}
                    style={{marginRight: '25px'}}
                >
                </Button>
                <Button
                    type="submit"
                    title="Sil"
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={() => this.deleteRow(rowData['md_id'])}
                >
                </Button>

            </div>


        </div>;
    }


    render() {


        let rfg_header = (

            <div style={{'textAlign': 'center'}}>
                Kayıtlı Modüller &nbsp;&nbsp;
                <Button icon="pi pi-plus-circle"
                        title="Modül Ekle"
                        className="p-button-info"
                        onClick={() => this.setState({moduleDialog: true})}
                />
            </div>

        );

        return (
            <div>
                <div className="content-section introduction">
                    <div className="feature-intro">
                        <h1 style={{color: 'darkgray'}}><b>Modül Yönetimi</b></h1>
                    </div>
                </div>
                <Dialog header="UYARI" visible={this.state.moduleDeleteDialog}
                        style={{width: '20%'}}
                        footer={this.renderFooter()}

                        onHide={() => this.setState({moduleDeleteDialog: false})}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>Silmek İstediğinizden Emin Misiniz?</span>
                    </div>


                </Dialog>

                <div className="content-section implementation">

                    <DataTable
                        value={this.state.md_list}
                        header={rfg_header}
                        filterBy="username"
                        selectionMode="single"
                        emptyMessage="Kayıt bulunamadı"
                        paginator={true}
                        rows={12}
                        responsive={true}>
                        <Column
                            field="md_id"
                            style={{fontSize: '13px'}}
                            header="No"
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            field="md_name"
                            style={{fontSize: '13px'}}
                            header="Ad"
                            sortable={true}
                            filter={true}
                        />
                        <Column
                            field="md_code"
                            style={{fontSize: '13px'}}
                            header="Kod"
                            sortable={true}
                            filter={true}/>
                        <Column
                            field="md_locksystem"
                            style={{fontSize: '13px'}}
                            header="Kilit Sistemi"
                            sortable={true}
                            filter={true}/>
                        <Column field="md_url" header="Url" sortable filter={true}/>
                        <Column
                            header="İşlevler"
                            body={this.actionTemplate}
                            style={{width: "150px"}}
                        />

                    </DataTable>
                    <Dialog header="Modül Ekle"
                            visible={this.state.moduleDialog}
                            style={{width: '40vw'}}
                            onHide={() => this.setState({moduleDialog: false})} maximizable>
                        <form onSubmit={this.onSubmit}>
                            <div className="p-grid">


                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Ad
                                    </label>
                                    <span style={{color: "red"}}> (*)</span>
                                </div>
                                <div className="p-col-12 p-md-10 p-lg-10">
                                    <InputText
                                        value={this.state.md_name}

                                        onChange={this.onChangeName}
                                        style={{width: '80%'}}
                                        name="build_name"
                                        placeholder="Modül Adı Giriniz"
                                        required/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Kod
                                    </label>
                                    <span style={{color: "red"}}> (*)</span>
                                </div>
                                <div className="p-col-12 p-md-10 p-lg-10">
                                    <InputText
                                        value={this.state.md_code}

                                        onChange={this.onChangeCode}
                                        style={{width: '80%'}}
                                        name="build_name"
                                        placeholder="Modül Kodu Giriniz"
                                        required/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Url
                                    </label>
                                    <span style={{color: "red"}}> (*)</span>
                                </div>
                                <div className="p-col-12 p-md-10 p-lg-10">
                                    <InputText
                                        value={this.state.md_url}

                                        onChange={this.onChangeUrl}
                                        style={{width: '80%'}}
                                        placeholder="Url Giriniz"
                                        required/>
                                </div>


                                <div className="p-col-12 p-md-10 p-lg-12" align="right">
                                    <Button label="Ekle" icon="pi pi-check" iconPos="left" style={{
                                        display: this.state.clean_button_add,
                                        width: '150px',
                                        background: 'deepskyblue',
                                        top: '10px'
                                    }}
                                            onClick={() => this.setState({moduleDialog: false})}
                                    /></div>


                            </div>
                        </form>


                    </Dialog>
                </div>
            </div>
        )


    }
}




// WEBPACK FOOTER //
// ./src/pages/modulemanagement/ModuleManagement.jsx